import {createReducer, on} from '@ngrx/store'
import {errorsStanPoczatkowy} from './types/errors-stan-poczatkowy'
import {toErrorsPage} from './errors.actions'
import {ErrorsInterface} from './types/errors-stan.interface'

export const errorsReducers = createReducer(
  errorsStanPoczatkowy,
  on(toErrorsPage, (state, action: {payload: ErrorsInterface}): ErrorsInterface => action.payload)
)
